<ng-container *ngIf="working; else availableIcon">
  <mat-icon
    class="availability-icon booked"
    [class.small-icon]="size === 'small'"
    [matTooltip]="availability?.note || ''"
    matTooltipPosition="above"
    svgIcon="star-circle-outline"></mat-icon>
</ng-container>
<ng-template #availableIcon>
  <ng-container *ngIf="availability?.isAvailable; else unavailableIcon">
    <mat-icon
      class="availability-icon available"
      [class.small-icon]="size === 'small'"
      [matTooltip]="availability?.note || ''"
      matTooltipPosition="above"
      [svgIcon]="
        availability?.note ? 'check-circle-alert' : 'check-circle'
      "></mat-icon>
  </ng-container>
</ng-template>
<ng-template #unavailableIcon>
  <ng-container *ngIf="availability?.isAvailable === false; else undecidedIcon">
    <mat-icon
      class="availability-icon unavailable"
      [class.small-icon]="size === 'small'"
      [matTooltip]="availability?.note || ''"
      matTooltipPosition="above"
      svgIcon="close-circle"></mat-icon>
  </ng-container>
</ng-template>
<ng-template #undecidedIcon>
  <mat-icon
    class="availability-icon undecided"
    [class.small-icon]="size === 'small'"
    [matTooltip]="availability?.note || ''"
    matTooltipPosition="above"
    svgIcon="help-circle-outline"></mat-icon>
</ng-template>
